export default {
  styleOverrides: {
    root: {
      color: "#5a5b6a",
      "&.Mui-focused": {
        color: "#000",
      },
    },
  },
};
